import axios from '../axios';

const getProjectTelegramBotAccesses = async (botId: string) => {
  const { data } = await axios.get(`/telegram-bots/${botId}/accesses`);

  return data;
};

export default getProjectTelegramBotAccesses;
